import {addHttps} from "../../../../../gd/utils/link_and_url/links";

export default function FieldUrl_ActionClick(url:string) {

    // url = FormatLinks.addHttps(url);
    url = addHttps(url);

    try {
        window.open(url);
    } catch (error) {
        gd.growl.error("Cannot open link "+url);
    }
}